import { FC } from 'react'
import styled from 'styled-components'
import { validFor } from '@/theme/validFor'
import useTranslation from 'next-translate/useTranslation'
import { LandingPage } from '@/network/graphql.g'
import { Flex } from '@/components/atoms/Grid'
import { Body2, H1 } from '@/components/atoms/typography'
import { SectionSeparator } from '@/components/atoms/separator'

type SummerHeaderProps = {
  landingPage: LandingPage
}

const servicesData: {
  title: string
  id: number
}[] = [
  {
    id: 1,
    title: 'Menu.Promotions.goodsComplaint'
  },
  {
    id: 2,
    title: 'Menu.Promotions.freeShipping'
  },
  {
    id: 3,
    title: 'Menu.Promotions.discounts'
  }
]

const SummerHeader: FC<SummerHeaderProps> = ({ landingPage }) => {
  const { t } = useTranslation('common')

  return (
    <Flex flexDirection="column" alignItems="center" width="100%">
      <StyledH1>{landingPage.name}</StyledH1>
      <StyledServicesData
        flexDirection={{
          mobile: 'column',
          tablet: 'row',
          desktop: 'row'
        }}
      >
        {servicesData.map((service, id) => (
          <Flex key={id}>
            <StyledBodyText>{t(service.title)}</StyledBodyText>
            <StyledSectionSeparator height={15} isVertical mx="10px" />
          </Flex>
        ))}
      </StyledServicesData>
    </Flex>
  )
}

export default SummerHeader

const StyledH1 = styled(H1)`
  text-transform: uppercase;
  margin: 30px 0 12px 0;
`
const StyledServicesData = styled(Flex)`
  justify-content: space-around;
  padding: 16px 0;
  width: 100%;
  background-color: ${(props) => props.theme.colors.menuBackground};
  & div:last-child div:last-child {
    display: none;
  }
  ${validFor.mobile`
    display: none;
  `}
`

const StyledBodyText = styled(Body2)`
  text-align: center;
  margin: 0;
  text-transform: uppercase;
  opacity: 0.5;
`

const StyledSectionSeparator = styled(SectionSeparator)`
  font-weight: bold;
  background-color: ${(props) => props.theme.colors.onBackground};
  opacity: 0.5;
  width: 2px;
  ${validFor.desktop`
    margin: 0 130px;
  `}
  ${validFor.tablet`
    margin: 0 40px;
  `}
`
